"use strict";

var _createForOfIteratorHelper = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hoist = hoist;
var _TBlockCtor = _interopRequireDefault(require("../tree/TBlockCtor"));
var _TPhrasingCtor = require("../tree/TPhrasingCtor");
var _TTextCtor = require("../tree/TTextCtor");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * Wrap text nodes around TPhrasing nodes.
 * @param tnode The parent node of all elements to group.
 */
function groupText(tnode) {
  var newChildren = [];
  var wrapperInit = {
    elementModel: null,
    context: tnode.init.context,
    // We need to merge styles here to make sure
    // some React Native styles working only for the uppermost Text element
    // such as "textAlign" are preserved.
    parentStyles: tnode.styles,
    parent: null
  };
  var wrapper = new _TPhrasingCtor.TPhrasingCtor(wrapperInit);
  var wrapperChildren = [];
  var _iterator = _createForOfIteratorHelper(tnode.children),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var child = _step.value;
      if (child instanceof _TTextCtor.TTextCtor || child instanceof _TPhrasingCtor.TPhrasingCtor) {
        wrapperChildren.push(child);
      } else {
        if (wrapperChildren.length) {
          newChildren.push(wrapper);
          wrapper.bindChildren(wrapperChildren);
          wrapper = new _TPhrasingCtor.TPhrasingCtor(wrapperInit);
          wrapperChildren = [];
        }
        newChildren.push(child);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (wrapperChildren.length) {
    wrapper.bindChildren(wrapperChildren);
    newChildren.push(wrapper);
  }
  tnode.bindChildren(newChildren);
  return tnode;
}
function hoistNode(tnode) {
  if (tnode instanceof _TTextCtor.TTextCtor) {
    return tnode;
  }
  tnode.bindChildren(tnode.children.map(hoistNode));
  if (tnode instanceof _TPhrasingCtor.TPhrasingCtor) {
    var _iterator2 = _createForOfIteratorHelper(tnode.children),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var cnode = _step2.value;
        if (cnode instanceof _TBlockCtor.default) {
          var newNode = new _TBlockCtor.default(tnode.cloneInitParams());
          newNode.bindChildren(tnode.children);
          var output = groupText(newNode);
          return output;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  } else if (tnode instanceof _TBlockCtor.default) {
    if (tnode.children.length > 0) {
      var _output = groupText(tnode);
      return _output;
    }
  }
  return tnode;
}
function hoist(tree) {
  return hoistNode(tree);
}